var React = require('react');

function MoeComments (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M.474.556v73.595h.001l22.117-22.127h47.941V.556H.474zm5 5h60.06v41.468H20.52L5.474 62.077V5.555z","key":0}),React.createElement("path",{"d":"M16.74 21.819h37.529v-5H16.74zM16.74 35.76h37.529v-5H16.74z","key":1})]));
}

MoeComments.defaultProps = {"width":"71","height":"75"};

module.exports = MoeComments;

MoeComments.default = MoeComments;
